<div
  class="step-item card full-width"
  [ngClass]="{ boxed: service.stepHover && !service.taskHover }"
>
  <div class="card-header p-1">
    <div class="d-flex full-width align-items-center justify-content-between">
      <div class="d-flex">
        <h5
          class="m-0"
          *ngIf="!editing"
          [ngClass]="{
            'step-name': !disabled,
            'step-name-nohover': disabled,
          }"
          (click)="!disabled ? (editing = true) : null"
        >
          {{ step.name }}
        </h5>
        <h5 *ngIf="editing" class="m-0 input-sizer stacked">
          <textarea
            aria-label="text"
            matInput
            onmouseover="this.parentNode.dataset.value = this.value"
            onfocus="this.parentNode.dataset.value = this.value"
            oninput="this.parentNode.dataset.value = this.value"
            (change)="editing = false"
            rows="1"
            [(ngModel)]="step.name"
            appTextareaAutoresize
            style="overflow: hidden; height: 100%"
            (mousedown)="$event.stopPropagation()"
            (touchstart)="$event.stopPropagation()"
          >
          </textarea>
        </h5>
      </div>
      <div class="d-flex">
        <div class="d-flex icons-div align-items-center justify-content-end">
          <mat-icon
            class="yellow mx-2"
            [matTooltip]="step.code"
            *ngIf="step.code"
            >sell</mat-icon
          >
          <mat-icon
            class="red mx-2"
            *ngIf="step.restrictSubmitter"
            matTooltip="Restrict Sbmitter to sign on this Step"
            >person_off</mat-icon
          >
          <mat-icon
            class="blue mx-2"
            *ngIf="step.samePersonApprove"
            matTooltip="Multiple Signatures allowed for the same person"
            >people_alt</mat-icon
          >
          <mat-icon
            class="gray mx-2"
            *ngIf="
              !step.samePersonApprove && (step.wfTaskConfigs?.length ?? 0) > 1
            "
            matTooltip="No Multiple Signatures allowed"
            >group_off</mat-icon
          >
          <mat-icon
            class="green mx-2"
            *ngIf="step.fullWidth"
            matTooltip="Full Width Layout"
            >width_full</mat-icon
          >
          <status-chips [stepStatusConfigs]="step.wfStepStatusConfigs">
          </status-chips>

          <button
            class="status-button small"
            [matMenuTriggerFor]="settings"
            mat-flat-button
            [ngClass]="step.wfStepStatusConfigs?.[0]?.formStatus?.color + '-bg'"
          >
            <mat-icon class="white m-0">settings</mat-icon>
          </button>
          <mat-menu class="no-padding-menu" #settings="matMenu">
            <div class="card">
              <div
                class="card-header"
                (mousedown)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
              >
                <span class="card-title">Step Settings</span>
              </div>

              <div
                class="card-body"
                (mousedown)="$event.stopPropagation()"
                (touchstart)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
              >
                <mat-form-field appearance="outline">
                  <mat-label>Step Tag</mat-label>
                  <input
                    matInput
                    uppercase
                    [(ngModel)]="step.code"
                    [disabled]="!!disabled"
                    (mousedown)="$event.stopPropagation()"
                    (touchstart)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Activate Form Status</mat-label>

                  <mat-select
                    #statusSelect
                    multiple
                    [(value)]="step.selectedStatuses"
                    (selectionChange)="setStatuses($event.value)"
                  >
                    <mat-select-trigger>
                      <mat-chip-set>
                        <mat-chip
                          class="status-chip"
                          [ngClass]="getStatusClass(id)"
                          *ngFor="let id of step.selectedStatuses"
                        >
                          {{ getStatusName(id) }}
                        </mat-chip>
                      </mat-chip-set>
                    </mat-select-trigger>

                    <mat-option
                      class="small"
                      *ngFor="let s of formStatuses"
                      [value]="s.id"
                      [ngClass]="s.color"
                    >
                      {{ s.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-slide-toggle
                  class="small"
                  [(ngModel)]="step.samePersonApprove"
                  [disabled]="!!disabled"
                  (mousedown)="$event.stopPropagation()"
                  (click)="$event.stopPropagation()"
                  >Same person can Approve</mat-slide-toggle
                >
                <mat-slide-toggle
                  class="small"
                  [(ngModel)]="step.restrictSubmitter"
                  [disabled]="!!disabled"
                  (mousedown)="$event.stopPropagation()"
                  (click)="$event.stopPropagation()"
                  >Restrict Submitter to Sign</mat-slide-toggle
                >
                <hr />
                <mat-slide-toggle
                  class="small"
                  [(ngModel)]="step.fullWidth"
                  [disabled]="!!disabled"
                  (mousedown)="$event.stopPropagation()"
                  (click)="$event.stopPropagation()"
                  >Full Width</mat-slide-toggle
                >
              </div>
              <div class="card-footer">
                <div mat-dialog-actions align="center">
                  <button mat-flat-button class="blue">Close</button>
                </div>
              </div>
            </div>
          </mat-menu>
        </div>

        <div class="d-flex" *ngIf="!disabled">
          <button
            mat-icon-button
            *ngIf="!disabled && step.id"
            (click)="duplicate.emit(step)"
            color="primary"
            matTooltip="Duplicate Step"
          >
            <mat-icon>content_copy</mat-icon>
          </button>
          <button
            mat-icon-button
            *ngIf="!disabled"
            color="warn"
            (click)="delete.emit(step)"
            matTooltip="Delete Step"
          >
            <mat-icon>delete</mat-icon>
          </button>
          <button
            mat-icon-button
            *ngIf="!disabled"
            color="accent"
            (click)="tasks.addTaskDialog()"
            matTooltip="Add Task"
          >
            <mat-icon>add_box</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body p-1 d-flex align-items-center justify-content-center">
    <workflow-tasks
      #tasks
      class="full-width full-height d-flex-flex-column"
      [wfTableConfig]="wfTableConfig"
      [step]="step"
      [disabled]="disabled"
      [stepDropLists]="stepDropLists"
    ></workflow-tasks>
  </div>
</div>
